import sanitizeHtml from 'sanitize-html';

function sanitize(dirty) {
    return sanitizeHtml(dirty, {
        allowedTags: sanitizeHtml.defaults.allowedTags.concat([
            'img',
            'iframe',
        ]),
        allowedAttributes: {
            '*': ['style'],
            a: ['href'],
            img: ['src', 'alt'],
            iframe: ['src', 'width', 'height'],
        },
        allowedStyles: {
            '*': {
                // Match HEX and RGB
                color: [
                    /^#(0x)?[0-9a-f]+$/i,
                    /^[a-z]+$/i,
                    /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/,
                ],
                'text-align': [/^left$/, /^right$/, /^center$/],
                // Match any number with px, em, or %
                'font-size': [/^\d+(?:px|em|%)$/],
                margin: [/.*/],
            },
            p: {
                'font-size': [/^\d+rem$/],
            },
        },
        allowedIframeHostnames: ['www.google.com'],
    });
}

const SafeHtml = ({ html }) => {
    return (
        <div
            dangerouslySetInnerHTML={{ __html: sanitize(html) }}
            className="whitespace-pre-wrap"
        ></div>
    );
};

export default SafeHtml;
